<template>
    <div :class="'config-group small-12 column d-flex flex-column align-items-center'">
        <div :class="'dropflex position-relative config-item w-100 my-auto position-relative'">
            <Tooltip v-if="tooltip" :infoText="tooltip" />

            <div class="row my-children-2">
                <div class="small-12 column">
                    <div class="config-group-outline px-prj2 py-prj px-3@large border">
                      <template v-for="(auspraegung, index) in selectable">
                        <div :key="'div' + auspraegung.id"
                             class="config-item__info d-inline-flex flex-column py-prj2 py-prj3@large w-100">

                          <input

                              type="radio"
                              :name="auspraegung.name"
                              :value="auspraegung.id"
                              :id="auspraegung.id"
                              v-model="productionSelection">

                          <label :for="auspraegung.id" class="label-aligned font-weight-bold">
                            <span class="mainlabel">{{ auspraegung.name }}</span>
                            <span
                                class="font-weight-light font-italic d-block@until-large text-small@until-medium">{{ getDeliveryDate(auspraegung.id) }}</span>
                          </label>

                                <OptionLieferart
                                    v-if="optionLieferart && productionSelection == auspraegung.id"
                                    :option="optionLieferart"
                                    :prefix="auspraegung.id"
                                    :currentSelection="liefertSelection"
                                    v-model="liefertSelection"
                                />

                            </div>
                            <hr class="m-0 bg-shade"
                                v-if="index < selectable.length - 1"
                                :key="'hr' + auspraegung.id" />
                        </template>
                    </div>
                </div>
            </div>
          <div v-if="option.currentInfo.msgType === 'INFO'" class="text-small mt-prj text-info d-flex line-height-12">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px" x="0"
                 y="0"
                 viewBox="0 0 36 36" xml:space="preserve"><path d="M36 18.01c0 9.94-8.04 17.98-17.99 17.99C8.03 36.01-.01 27.95 0 17.93 0 8.04 8.09-.01 18.02 0 27.96.01 36 8.06 36 18.01z" fill="#62b982"/>
              <path id="XMLID_1_"
                    d="M14.93 26.67l-6.46-6.46a2.07 2.07 0 010-2.93 2.07 2.07 0 012.93 0l3.55 3.55 9.66-9.56c.81-.8 2.12-.8 2.93.02.8.81.8 2.12-.02 2.93L14.93 26.67z"
                    fill="#fff"/></svg>
            {{ option.currentInfo.text }}
          </div>
          <div v-if="option.currentInfo.msgType === 'ERROR'" class="text-small mt-prj text-error d-flex line-height-12">
            <svg xmlns="http://www.w3.org/2000/svg" class="mr-2 svg-icon flex-child-fix position-relative t-1px"
                 viewBox="0 0 36 36">
              <circle cx="18" cy="18" r="18" fill="#e94d47"/>
              <path
                  d="M16.08 26.43c0-.3.05-.58.17-.85.11-.27.26-.5.46-.69.2-.19.43-.35.7-.46.27-.12.56-.17.86-.17.3 0 .58.06.85.17.27.12.5.27.69.46.19.19.34.42.46.69.12.27.17.55.17.85 0 .31-.06.59-.17.86-.12.26-.27.49-.46.68-.19.19-.42.34-.69.45a2.223 2.223 0 01-1.71 0c-.27-.11-.5-.26-.7-.45-.2-.19-.35-.42-.46-.68-.11-.27-.17-.55-.17-.86zm3.9-18.86v8.24c0 .87-.04 1.73-.13 2.57-.09.84-.2 1.73-.34 2.67h-2.4c-.14-.94-.26-1.83-.35-2.67-.09-.84-.13-1.7-.13-2.57V7.57h3.35z"
                  fill="#fff"/>
            </svg>
            {{ option.currentInfo.text }}
          </div>

        </div>
    </div>
</template>
<script>
import Tooltip from "./Tooltip";
import OptionLieferart, {
  CONFIGOPTION_TYPE as CONFIGOPTION_TYPE_LIEFERART,
  EL_IDENTIFIER_DELIMITER as LIEFERART_EL_IDENTIFIER_DELIMITER
} from "./OptionLieferart";

export const CONFIGOPTION_TYPE = "Production";

    export default {
        components: {Tooltip, OptionLieferart},
        props: ["option"],
        inject: ['configuratorService'],
        data() {
            return {
            }
        },
        methods: {
            hideInfoAfterTimeout(){
                if( this.option.currentInfo.msgType === "INFO") {
                let self = this;
                let afterTimeout = function(){
                    self.option.currentInfo.msgType = "";
                }
                    setTimeout( afterTimeout, 2000);
                }
            },
            getDeliveryDate( auspraegungsId ) {
                return this.option.customValues[auspraegungsId]?.deliveryDate
            },
          isSelectable(id) {
            return !this.configuratorService.isAuspraegungExcluded(this.option, id)
          }
        },
        computed: {
            optionLieferart: function () {
                return this.configuratorService.byConfigoptionType(CONFIGOPTION_TYPE_LIEFERART)
            },
            liefertSelection: {
                get() {
                    let selected = this.configuratorService.getSelectedAuspraegung( this.optionLieferart );
                    if ( selected ) {
                        return this.productionSelection + LIEFERART_EL_IDENTIFIER_DELIMITER + this.configuratorService.getSelectedAuspraegung( this.optionLieferart ).id
                    }
                },
                set(value) {
                    let keys = value.split(LIEFERART_EL_IDENTIFIER_DELIMITER)
                    // this.configuratorService.setSelectedAuspraegung(this.option, keys[0], false) // skip validation
                    this.configuratorService.setSelectedAuspraegung(this.optionLieferart, keys[1]) // validation is executed with both new values
                }
            },
            productionSelection: {
                get() {
                    return this.configuratorService.getSelectedAuspraegung( this.option ).id
                },
                set(value) {
                    this.configuratorService.setSelectedAuspraegung( this.option, value )
                }
            },
          tooltip: function () {
            let out = ""
            if (this.option?.tooltip) {
              out = this.option.tooltip
            }
            return out
          },
          msgType() {
            return this.option.currentInfo.msgType;
          },
          selectable() {
            return this.option.auspraegungen.filter(x => x.status !== 'EXCLUDED')
          }
        },
        watch: {
            msgType: {
                immediate: true,
                handler() {
                    this.hideInfoAfterTimeout();
                }
            }
        }
    };
</script>
